import React, { useState, useRef, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper';
import axios from "axios";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';

const VideoTestimonials = () => {
    const [testimonials, setTestimonials] = useState([]);
    const [activeIndex, setActiveIndex] = useState(1);
    const videoRefs = useRef([]);
    const isFirstRender = useRef(true);

    useEffect(() => {
      axios.get("https://www.cadandrender.com/adminPanel/API/testimonials.php").then((response) => {
          if (response.data?.Testimonials) {
            setTestimonials(response.data.Testimonials);
          }
        });
    }, []);

    // Pause and reset non-active videos
    useEffect(() => {
      // Skip autoplay on first load
      if (isFirstRender.current) {
        isFirstRender.current = false;
        return;
      }

      videoRefs.current.forEach((video, index) => {
        if (video) {
          if (index === activeIndex) {
            video.play().catch(() => {});
          } else {
            video.pause();
            video.currentTime = 0;
          }
        }
      });
    }, [activeIndex]);

    const imageTestimonials = testimonials.filter(t => t.Testimonials_Type === 'image');
    const videoTestimonials = testimonials.filter(t => t.Testimonials_Type === 'video');
    const hasVideos = videoTestimonials.length > 0;

    return (
        <>
        <section className="testimonial-section">
          <div className="container">
            <h2>Testimonials</h2>
            <div className="row testimonialAln">
              
              {/* Image Testimonials Carousel */}
              <div className={`testimonial-image-area ${hasVideos ? 'col-4' : 'col-12'}`}>
                <Swiper
                    modules={[Pagination, Autoplay, Navigation]}
                    navigation={true}
                    loop={true}
                    autoplay={false}
                    slideToClickedSlide={true}
                    className="imageSwiper"
                    >
                    {imageTestimonials.map((testimonial, index) => (
                        <SwiperSlide key={index}>
                        <div className='testimonial-user'>
                          <img src={testimonial.Testimonials_MediaUrl} alt={`Testimonial ${index + 1}`} />
                        </div>
                        <p>{testimonial.Testimonials_UserMessage}</p>
                        <h5>- {testimonial.Testimonials_UserName}</h5>
                        </SwiperSlide>
                    ))}
                </Swiper>
              </div>
    
              {/* Video Testimonials Carousel */}
              {hasVideos && (
                <div className="testimonial-video-area col-8">
                  <Swiper
                    spaceBetween={0}
                    slidesPerView={3}
                    centeredSlides={true}
                    initialSlide={1}
                    autoplay={false}
                    modules={[Navigation, Pagination]}
                    allowTouchMove={false}
                    navigation={true}
                    watchSlidesProgress={true}
                    grabCursor={false}
                    slideToClickedSlide={true}
                    onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
                    className="videoSwiper"
                  >
                    {videoTestimonials.map((video, index) => (
                      <SwiperSlide key={index} className="video-slide">
                        <div className="video-wrapper">
                          <video controls={index === activeIndex} ref={(el) => (videoRefs.current[index] = el)}>
                            <source src={video.Testimonials_MediaUrl} type="video/mp4" />
                            Your browser does not support the video tag.
                          </video>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  {/* Active video testimonial content displayed outside SwiperSlide */}
                  {videoTestimonials[activeIndex] && (
                    <div className="active-testimonial-content">
                      <p>{videoTestimonials[activeIndex].Testimonials_UserMessage}</p>
                      <h5>- {videoTestimonials[activeIndex].Testimonials_UserName}</h5>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </section>
        </>
    );
};

export default VideoTestimonials;